import styled from 'styled-components';

export const SubmissionMenuWrapper = styled.div`
  border-radius: 4px;
  border: 1px solid light-dark(#ced4da, var(--mantine-color-dark-4));
  background: light-dark(var(--mantine-color-body), var(--mantine-color-dark-6));
  box-shadow:
    0px 1px 2px 0px light-dark(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.4)),
    0px 1px 3px 0px rgba(0, 0, 0, 0.05),
    0 8px 24px light-dark(transparent, rgba(0, 0, 0, 0.45));
  padding: 8px;
`;

export const SubmissionMenuItem = styled.button`
  width: 110px;
  display: flex;
  padding: 8px;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  padding: 8px;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 16.8px */
  border-radius: 4px;
  background: var(--mantine-color-body);
  cursor: pointer;
  text-align: left;

  &:hover {
    background: light-dark(#f1f3f5, var(--mantine-color-dark-5));
  }
`;
